/* =============================================================
   MAP CONFIG
   =============================================================
   Everything the map service needs that is a decision rather
   than a mechanism: where the tiles come from, what the map
   looks at when it has nothing to look at, and how far it will
   zoom.

   Tiles are OpenStreetMap's own: free, no key, and the same as
   the admin panel. Their usage policy suits light, attributed use
   -- a demo and a pilot -- not production traffic; launching the
   app for real means a tile provider with a plan. Swapping is
   this object plus `img-src` in public/_headers. (CARTO's basemaps
   were tried first and now answer with an API-key-required tile.)
   ============================================================= */

export const mapConfig = {
  tiles: {
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    /** Required by the OSM tile policy. Leaflet renders it bottom-right. */
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19,
  },

  /**
   * Roughly the middle of the European inland waterway network — used only
   * when there is nothing to fit the view to. Every map with points fits its
   * bounds instead.
   */
  fallbackCentre: { lat: 49.5, lng: 9.0 },
  fallbackZoom: 5,

  /** How close fitBounds is allowed to go, so one berth is not a street view. */
  maxFitZoom: 16,
  /** Breathing room around the fitted bounds, in px. */
  fitPadding: 48,
} as const
